export function delay(ms: number, callback: () => void): DelayResult {

  const timer = setTimeout(callback, ms);
  return {
    cancel: () => clearTimeout(timer)
  };
}

export function defer(callback: () => void): void {
  setTimeout(callback, 0);
}

export interface DelayResult {
  cancel: () => void;
}
